<template>
  <div
    class="th col"
    :class="{
      [`col-${cols}`]: !!cols,
      top: borderTop,
      no_border: noBorder
    }"
  >
    <slot />
  </div>
</template>
<script>
export default {
  name: 'TableHeading',
  props: {
    cols: {
      type: [Number, String],
      default: ''
    },
    borderTop: Boolean,
    noBorder: Boolean
  }
}
</script>
